import { cartFieldsOptimised } from '@pylot-data/core-queries/cart'

export const updateCartItemsMutation = /* GraphQL */ `
  mutation updateCartItems($input: UpdateCartItemsInput, $isSignedIn: Boolean = false) {
    updateCartItems(input: $input){
      cart {
        ${cartFieldsOptimised}
      }
    }
  }
`
